import React from "react";

function ReportDownloadOverlay({ show }) {
    if (!show) return null;
    return (
        <div
            className="report-download-overlay"
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(255, 255, 255, 0.9)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 9999,
            }}
        >
            <div className="report-download-overlay-content" style={{ textAlign: "center" }}>
                <div
                    className="report-download-spinner"
                    style={{
                        width: 48,
                        height: 48,
                        margin: "0 auto 16px",
                        border: "4px solid #e9ecef",
                        borderTopColor: "#405189",
                        borderRadius: "50%",
                        animation: "report-download-spin 0.8s linear infinite",
                    }}
                    role="status"
                    aria-label="Preparing download"
                />
                <p style={{ margin: 0, fontSize: "1rem", fontWeight: 500, color: "#405189" }}>
                    Preparing download...
                </p>
                <p style={{ margin: "8px 0 0", fontSize: "0.875rem", color: "#6c757d" }}>
                    Please wait, do not close this page.
                </p>
            </div>
            <style>{`
                @keyframes report-download-spin {
                    to { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );
}
export default ReportDownloadOverlay;
